import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { ISnowBallCard } from '../Card/ISnowBallCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'
import { SnowBallNFTJson } from '../../../data/NFTCollections/SnowBallData'

export default function SnowBallDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<ISnowBallCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  const tokenName = `${collection.name} #${tokenItem.tokenId}`

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      let tokenUri = tokenItem.tokenUri

      if (SnowBallNFTJson[collection.id]) {
        tokenUri = `https://raw.githubusercontent.com/Snowball-Finance/NFTs/main/${SnowBallNFTJson[collection.id]}`
      }

      Api.get(tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : <></>}
      tokenItemName={tokenName}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? <img src={detailTokenItem.image} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
